import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { apiPublicPost } from '../api';
import '../App.css';

// Public one-click unsubscribe landing page. The email footer / List-Unsubscribe
// link lands here with ?e=<email>&t=<hmac>; we record the opt-out immediately, through
// POST /public/unsubscribe (#1127).
const UnsubscribePage: React.FC = () => {
  const [params] = useSearchParams();
  const email = params.get('e') || '';
  const token = params.get('t') || '';
  const [status, setStatus] = useState<'working' | 'done' | 'error'>('working');

  useEffect(() => {
    if (!email || !token) { setStatus('error'); return; }
    apiPublicPost('/public/unsubscribe', { email, token })
      .then(() => setStatus('done'))
      .catch(() => setStatus('error'));
  }, [email, token]);

  return (
    <div className="unsub-page">
      <img src="/chaptery-mark.svg" alt="Chaptery" className="unsub-logo" />
      {status === 'working' && <p className="unsub-msg">Updating your email preferences…</p>}
      {status === 'done' && (
        <>
          <h1 className="unsub-h1">You're unsubscribed</h1>
          <p className="unsub-msg">
            {email ? <><b>{email}</b> won't</> : "You won't"} receive Chaptery update emails anymore.
            You'll still get important account and billing emails.
          </p>
        </>
      )}
      {status === 'error' && (
        <>
          <h1 className="unsub-h1">This link didn't work</h1>
          <p className="unsub-msg">
            The unsubscribe link is invalid or expired. Email{' '}
            <a href="mailto:admin@trychaptery.com">admin@trychaptery.com</a> and we'll take you off the list.
          </p>
        </>
      )}
      <Link to="/" className="unsub-link">&larr; Back to tryChaptery.com</Link>
    </div>
  );
};

export default UnsubscribePage;
